<template>
  <div>
    <div class="input-wrapper">
      <div class="option"><label>Options</label></div>
      <div><label class="default">Default</label></div>
    </div>
    <b-row v-for="(choice, index) in item.field_choice" :key="index">
      <b-col class="input-wrapper mb-2">
        <div>
          <div class="content-between column-gap-lg">
            <font-awesome-icon
              icon="chevron-circle-up"
              @click="sortOrder(choice, index, false)"
              :class="`icon-size ${index == 0 ? 'disabled' : 'pointer'}`"
            />
            <span style="width: 10px" class="text-center">
              {{ index + 1 }}
            </span>
            <font-awesome-icon
              icon="chevron-circle-down"
              @click="sortOrder(choice, index, true)"
              :class="`icon-size ${
                index == item.field_choice.length - 1 ? 'disabled' : 'pointer'
              }`"
            />
          </div>
        </div>

        <div class="input">
          <InputText
            class="mb-0"
            textFloat=""
            v-model="choice.name"
            :placeholder="choice.name"
            :disabled="!isEditable || [1, 2, 3, 4].includes(choice.id)"
            type="text"
          />
        </div>

        <b-form-checkbox
          :id="`checkbox-question-default-${index}`"
          :name="`checkbox-question-default-${index}`"
          v-model="choice.isDefault"
          :value="1"
          :unchecked-value="0"
          class="mb-0"
          @change="SelectIsDefault(index, $event)"
        ></b-form-checkbox>

        <b-icon
          v-if="(isEditable && !isDisable) || ![1, 2, 3, 4].includes(choice.id)"
          size="lg"
          icon="trash-fill"
          class="icon-size pointer"
          @click="onDeleteChoice(item, index)"
        />
      </b-col>
    </b-row>
    <b-row v-if="isEditable">
      <b-col sm="6" class="mt-3 d-flex align-items-center">
        <span class="mr-4">{{ (item?.field_choice?.length || 0) + 1 }}</span
        ><span
          class="text-underline pointer"
          @click="addChoice(item.field_choice)"
          >Add Option</span
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
export default {
  name: "FieldChoiceDetail",
  components: {
    InputText,
  },
  props: {
    item: {
      required: true,
      type: Object,
    },
    isEditable: {
      default: true,
      type: Boolean,
    },
    isDisable: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      isLoading: true,
      isBusy: false,
    };
  },
  methods: {
    deleteChoice(index) {
      if (!this.isEditable) return;
      this.item.field_choice.splice(index, 1);
    },
    addChoice(item) {
      if (!this.isEditable) return;
      let len = item.length + 1;
      item.push({
        name: "choice " + len,
        sort_order: item.length,
        isDefault: 0,
      });
    },
    async SelectIsDefault(index, val) {
      if (this.item.field_type_id != 2) {
        this.item.field_choice.forEach((c, i) => {
          if (i == index) {
            c.isDefault = val || 0;
          } else {
            c.isDefault = 0;
          }
        });
      }
    },
    onDeleteChoice(item, index) {
      item.field_choice.splice(index, 1);
    },
    async sortOrder(items, index, mode) {
      if (index == 0 && !mode) {
        return;
      }

      this.item.field_choice.splice(index, 1);
      index = mode ? index + 1 : index - 1;

      this.item.field_choice.splice(index, 0, items);
      let payload = JSON.parse(
        JSON.stringify(
          this.item.field_choice.map((a, b) => {
            return { ...a, sort_order: b + 1 };
          })
        )
      );
      this.$nextTick(() => {
        this.item.field_choice = [...payload];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-size {
  font-size: 20px;
  color: #575757;
}
.icon-size.disabled {
  color: #bababa;
}
.input-wrapper {
  display: flex;
  align-items: center;
  gap: 24px;

  .option {
    width: calc(50% + 83px);
  }

  .sequence {
    width: 20px;
  }

  .input {
    width: 50%;
  }
}
</style>
